'use client'

import LoginButton from '@/components/auth/LoginButton'
import RegisterButton from '@/components/auth/RegisterButton'
import { useAuthModal } from '@/components/auth/useAuthModal'
import NotificationsTrigger from '@/components/notifications/notifications-trigger'
import ShortRoundedLogo from '@/components/short-logo-p'
import useAuth from '@/hooks/use-auth'
import { Link } from '@/navigation'
import { Flex } from '@/styled-system/jsx'
import Deposit from '../header-deposit'
import RakebackBoost from '../header-rakeback-boost'
import UserMenu from '../header-user-menu'
import RewardsTrigger from '../rewards-dropdown/header-rewards-trigger'

export default function MobileHeader({
  onClickLogo,
}: {
  onClickLogo?: () => void
}) {
  const { isAuthenticating, isAuthenticated } = useAuth()
  const { onOpen } = useAuthModal()

  return (
    <>
      <Link prefetch={true} href='/' onClick={onClickLogo}>
        <ShortRoundedLogo />
      </Link>

      {isAuthenticating ? null : (
        <>
          {isAuthenticated ? (
            <Flex
              align='center'
              justify='flex-end'
              flex='1'
              pl={{ '2xl': '4' }}
              gap={{ base: '2.5', lg: '4' }}
            >
              <Flex
                flex={1}
                gap='3.5'
                justify={{ base: 'flex-end', sm: 'flex-start' }}
                position={{ base: 'relative', xl: 'absolute' }}
                left={{ xl: '50%' }}
                transform={{ xl: 'translateX(-50%)' }}
                zIndex='50'
              >
                <Deposit />
                <RakebackBoost />
              </Flex>

              <UserMenu />

              <NotificationsTrigger redirect />
            </Flex>
          ) : (
            <Flex align='center' gap={1} grow='1'>
              <RewardsTrigger
                display={{ base: 'none', lg: 'flex' }}
                onClick={() => onOpen('login')}
              />

              <Flex align='center' gap={1} ml='auto'>
                <LoginButton />
                <RegisterButton />
              </Flex>
            </Flex>
          )}
        </>
      )}
    </>
  )
}
